import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import '../../css/layout.css';


export function CreateEmployeeModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);

    const [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [sessionID, setSessionID ] = useState(authenticated_Zasava_Context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [selectedFile, setSelectedFile] = useState(null);

    let employeeCompanyRoleRef = useRef('individual_contributor');
    let employeeFirstNameRef = useRef();
    let employeeLastNameRef = useRef();
    let initialEmployeePasswordRef = useRef();
    let employeeHireDateRef = useRef();
    let employeeHourlyPayRef = useRef();
    let employeeJobFunctionRef = useRef();
    let employeePhoneNumberRef = useRef();
    let employeeEmailAddressRef = useRef();
    let employeeAddressNumberRef = useRef();
    let employeeStreetNameRef = useRef();
    let employeeCityRef = useRef();
    let employeeCityDistrictRef = useRef();
    //let employeeNearestLandmarkRef = useRef();
    let employeeCountryRegionRef = useRef();
    let employeeCountryRef = useRef();
    let employeeDigitalAddressIDRef = useRef();

    let selectedFileRef = useRef();

    function createEmployee(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74500);
        formData.append('user', acctID);
        formData.append('xEmployeeCompanyRole', employeeCompanyRoleRef.current.value);
        formData.append('xEmployeeFirstName', employeeFirstNameRef.current.value);
        formData.append('xEmployeeLastName', employeeLastNameRef.current.value);
        formData.append('xInitialEmployeePassword', initialEmployeePasswordRef.current.value);
        formData.append('xEmployeeHireDate', employeeHireDateRef.current.value);
        formData.append('xEmployeeHourlyPay', employeeHourlyPayRef.current.value);
        formData.append('xEmployeeJobFunction', employeeJobFunctionRef.current.value);
        formData.append('xEmployeePhoneNumber', employeePhoneNumberRef.current.value);
        formData.append('xEmployeeEmailAddress', employeeEmailAddressRef.current.value);

        //formData.append('xEmployeeHomeAddress', employeeHomeAddressRef.current.value);
        formData.append('xEmployeeAddressNumber', employeeAddressNumberRef.current.value);
        formData.append('xEmployeeStreetName', employeeStreetNameRef.current.value);
        formData.append('xEmployeeCity', employeeCityRef.current.value);
        formData.append('xEmployeeCityDistrict', employeeCityDistrictRef.current.value);
        //formData.append('xEmployeeNearestLandmark', employeeNearestLandmarkRef.current.value);
        formData.append('xEmployeeCountryRegion', employeeCountryRegionRef.current.value);
        formData.append('xEmployeeCountry', employeeCountryRef.current.value);
        formData.append('xEmployeeDigitalAddressID', employeeDigitalAddressIDRef.current.value)

        formData.append('xSupportingDocumentation', selectedFileRef.current.value);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74500_createEmployee',
                user: acctID,
                xEmployeeCompanyRole: employeeCompanyRoleRef.current.value,
                xEmployeeFirstName: employeeFirstNameRef.current.value,
                xEmployeeLastName: employeeLastNameRef.current.value,
                xInitialEmployeePassword: initialEmployeePasswordRef.current.value,
                xEmployeeHireDate: employeeHireDateRef.current.value,
                xEmployeeHourlyPay: employeeHourlyPayRef.current.value,
                xEmployeeJobFunction: employeeJobFunctionRef.current.value,
                xEmployeePhoneNumber: employeePhoneNumberRef.current.value,
                xEmployeeEmailAddress: employeeEmailAddressRef.current.value,
                //xEmployeeHomeAddress:  employeeHomeAddressRef.current.value,
                xEmployeeAddressNumber: employeeAddressNumberRef.current.value,
                xEmployeeStreetName: employeeStreetNameRef.current.value,
                xEmployeeCity: employeeCityRef.current.value,
                xEmployeeCityDistrict: employeeCityDistrictRef.current.value,
                //xEmployeeNearestLandmark: employeeNearestLandmarkRef.current.value,
                xEmployeeCountryRegion: employeeCountryRegionRef.current.value,
                xEmployeeCountry: employeeCountryRef.current.value,
                xEmployeeDigitalAddressID: employeeDigitalAddressIDRef.current.value,
                xSupportingDocumentation: selectedFileRef.current.value,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            selectedFileRef.current.value = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            //setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            selectedFileRef.current.value = event.target.files[0];
            //setSelectedFile(event.target.files[0]);
        }


    }

    /*handleCreateEmployeeCompanyRole(e) 
    {   
        e.persist(); 
        employeeCompanyRoleRef.current.value = e.target.value;

    }*/

    function onSubmitPasswordHandler(enteredPassword)
    {
        //setEnteredPassword(event);
        createEmployee(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonContent className='appContent'>
            <IonGrid>
                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel for="employeeRole">Company Role</IonLabel>
                    <select name="employeeRole" id="employeeRole" ref={employeeCompanyRoleRef}>
                        <option value='human_resource'>HR</option>
                        <option value='sales'>Sales</option>
                        <option value='developer_frontend'>Front-End Developer</option>
                    </select>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Employee First Name:</IonLabel>
                    <IonInput placeholder="Enter First Name" ref={employeeFirstNameRef}></IonInput>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Employee Last Name:</IonLabel>
                    <IonInput placeholder="Enter Last Name" ref={employeeLastNameRef}></IonInput>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Employee Initial Login Password:</IonLabel>
                    <IonInput placeholder="Enter employee initial Login Password" ref={initialEmployeePasswordRef}></IonInput>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Hire Date</IonLabel>
                    {authenticated_Zasava_Context.device === 'mobile' && (
                    <IonDatetime displayFormat="MMM DD, YYYY" placeholder="Select Hire Date" ref={employeeHireDateRef}></IonDatetime>
                    )}
                    {authenticated_Zasava_Context.device === 'desktop' && (
                    <IonInput type="date" placeholder="Select Hire Date" ref={employeeHireDateRef}></IonInput>
                    )}
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Monthly Pay Rate:</IonLabel>
                    <IonInput placeholder="Enter Monthly Pay Rate" ref={employeeHourlyPayRef}></IonInput>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Job Function:</IonLabel>
                    <IonInput placeholder="Enter Job Function" ref={employeeJobFunctionRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Employee Phone Number:</IonLabel>
                    <IonInput placeholder="Enter Phone Number" ref={employeePhoneNumberRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Employee Email Address:</IonLabel>
                    <IonInput placeholder="Enter Email Address" ref={employeeEmailAddressRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Home Address Number:</IonLabel>
                    <IonInput placeholder="Enter Address Number" ref={employeeAddressNumberRef}></IonInput>
                    </IonItem>
                    <IonItem>
                    <IonLabel>Street Name:</IonLabel>
                    <IonInput placeholder="Enter Street Name" ref={employeeStreetNameRef}></IonInput>
                    </IonItem>
                    <IonItem>
                    <IonLabel>City:</IonLabel>
                    <IonInput placeholder="Enter City" ref={employeeCityRef}></IonInput>
                    </IonItem>
                    <IonItem>
                    <IonLabel>City District:</IonLabel>
                    <IonInput placeholder="Enter City District" ref={employeeCityDistrictRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Employee Country:</IonLabel>
                    <IonInput placeholder="Enter Country" ref={employeeCountryRef}></IonInput>
                    </IonItem>
                    <IonItem>
                    <IonLabel>Employee Country Region:</IonLabel>
                    <IonInput placeholder="Enter Country Region" ref={employeeCountryRegionRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonItem>
                    <IonLabel>Employee Digital Address ID:</IonLabel>
                    <IonInput placeholder="Enter Digital Address ID" ref={employeeDigitalAddressIDRef}></IonInput>
                    </IonItem>
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol>
                    <IonLabel>Attachment</IonLabel>
                    <IonItem>
                    <h1>Upload Supporting Documentation</h1>
                    <form id="fileUpload" enctype="multipart/form-data">
                        <input type="file" name="imageFile" accept="image/*" ref={selectedFileRef}></input>
                        <label for="noAttachment">No Attachment</label>
                        <input type="checkbox" id="noAttachment" value="noImage" ref={selectedFileRef}></input>
                    </form>
                    </IonItem>
                    <IonButton onClick={() => setShowPasswordModal(true)}>Create Employee</IonButton>
                    <EnterPasswordModal
                    openModal={showPasswordModal}
                    closeModal={() => setShowPasswordModal(false)}
                    onSubmitPassword={onSubmitPasswordHandler}
                    ></EnterPasswordModal>
                </IonCol>
                </IonRow>
            </IonGrid>
            </IonContent>
        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}